import { ref } from 'vue';
import { guidUtil } from '@/utils';
import FinanceiroCaixaMovService from './service';

const props = ref({
  ide: guidUtil.empty,
  Abertura: '',
  caixa__Codigo: '',
  caixa__Nome: '',
  aberturaUsuario__Ide: guidUtil.empty,
  caixa__Ide: guidUtil.empty,
  shipayClientId: '',
});

function setCaixa(data) {
  props.value = data;
}

function clearCaixaMov() {
  props.value.ide = guidUtil.empty;
  props.value.Abertura = '';
  props.value.caixa__Codigo = '';
  props.value.caixa__Nome = '';
  props.value.aberturaUsuario__Ide = guidUtil.empty;
  props.value.caixa__Ide = guidUtil.empty;
  props.value.shipayClientId = '';
}

export { props, setCaixa, clearCaixaMov, FinanceiroCaixaMovService };
